import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import LanguageContext from '../context/LanguageContext';
import { isAdminDashboardToken } from '../utils/authToken.js';

const isTokenValid = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    if (isAdminDashboardToken(token)) return false;
    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        if (decoded.exp && decoded.exp > now) return true;
    } catch (err) {
        // Ignore invalid token
    }
    if (!isAdminDashboardToken(token)) {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
    }
    return false;
};

const ProtectedRoute = ({ children }) => {
    const { currentLanguage } = useContext(LanguageContext);
    if (!isTokenValid()) {
        // Preserve catalog/theme preview query so guests are not stuck after login redirect.
        const search = typeof window !== 'undefined' ? window.location.search : '';
        const params = new URLSearchParams(search);
        const isThemePreview =
            params.get('catalogPreview') === '1' ||
            params.get('preview') === '1' ||
            params.has('themeId') ||
            params.has('hue');

        if (isThemePreview) {
            return (
                <Navigate
                    to={`/${currentLanguage || 'en'}${search}`}
                    replace
                />
            );
        }

        return <Navigate to={`/${currentLanguage || 'en'}/sign-in`} replace />;
    }
    return children;
};

export default ProtectedRoute;
